import { render, staticRenderFns } from "./ArNumberSticker.vue?vue&type=template&id=66abf78e&"
import script from "./ArNumberSticker.vue?vue&type=script&lang=ts&"
export * from "./ArNumberSticker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports